import { Link, useNavigate } from "react-router-dom";
import "../component/Header.css";

function Header({ isAuthenticated, setIsAuthenticated }) {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("user"); // Clear user data
        setIsAuthenticated(false); // Update authentication state
        navigate("/"); // Redirect to login
    };

    if (!isAuthenticated) return null; // Hide header if not authenticated

    return (
        <nav className="header">
            <div className="nav-container">
                <h1 className="logo">SEEREE</h1>
                <div className="nav-links">
                    <Link to="/landing">Home</Link>
                    <Link to="/exam">Exam</Link>
                    <span className="logout-link" onClick={handleLogout}>Logout</span>
                </div>
            </div>
        </nav>
    );
}

export default Header;
